import { heroCards } from "@/mocks/homeData";
import type { HeroCard } from "@/pages/home/types";

function HeroCardItem({ card, featured }: { card: HeroCard; featured?: boolean }) {
  if (featured) {
    return (
      <article className="flex h-full flex-col rounded-lg bg-primary-500 p-5 text-background-50">
        <span className="inline-flex w-fit items-center rounded-full bg-background-50/20 px-2.5 py-1 font-label text-[11px] tracking-wide">
          {card.tag}
        </span>
        <h3 className="mt-4 font-heading text-lg font-bold leading-snug">{card.title}</h3>
        <p className="mt-3 flex-1 text-[13px] leading-relaxed text-background-100">
          {card.summary}
        </p>
        <div className="mt-5 flex items-center justify-between border-t border-background-50/25 pt-3 font-label text-[11px]">
          <span className="inline-flex items-center gap-1.5">
            <i className="ri-chat-3-line" />
            {card.comments.toLocaleString()} 条讨论
          </span>
          <span>{card.date}</span>
        </div>
      </article>
    );
  }

  return (
    <article className="flex h-full flex-col rounded-lg border border-background-200 bg-background-100 p-5 transition-colors hover:border-primary-300">
      <span className="inline-flex w-fit items-center rounded-full bg-accent-100 px-2.5 py-1 font-label text-[11px] tracking-wide text-accent-900">
        {card.tag}
      </span>
      <h3 className="mt-4 font-heading text-lg font-bold leading-snug text-foreground-950">
        {card.title}
      </h3>
      <p className="mt-3 flex-1 text-[13px] leading-relaxed text-foreground-600">
        {card.summary}
      </p>
      <div className="mt-5 flex items-center justify-between border-t border-background-200 pt-3 font-label text-[11px] text-foreground-500">
        <span className="inline-flex items-center gap-1.5">
          <i className="ri-chat-3-line" />
          {card.comments.toLocaleString()} 条讨论
        </span>
        <span>{card.date}</span>
      </div>
    </article>
  );
}

export default function HeroGrid() {
  return (
    <section id="top" className="w-full px-4 pt-28 md:px-8 md:pt-36">
      <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-12 lg:gap-14">
        <div className="lg:col-span-7">
          <span className="inline-flex items-center gap-2 font-label text-xs tracking-[0.3em] text-primary-600">
            <span className="inline-block h-px w-8 bg-primary-500" />
            第 12 期 · 年度汇总特辑
          </span>
          <h2 className="mt-5 font-heading text-4xl font-black leading-[1.15] text-foreground-950 md:text-6xl">
            黑料网红大全
          </h2>
          <p className="mt-6 max-w-xl text-sm leading-relaxed text-foreground-600 md:text-base">
            把散落各处的讨论整理成可集中浏览的结构：名单、排行、盘点与合集分区陈列，
            年度汇总按时间顺序串起完整爆料脉络，点开即可集中浏览年度热门网红事件。
          </p>
          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
            <a
              href="#year"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-3 font-label text-sm text-background-50 transition-colors hover:bg-primary-600"
            >
              查看年度汇总
              <i className="ri-arrow-right-line" />
            </a>
            <a
              href="#comments"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-5 py-3 font-label text-sm text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-600"
            >
              <i className="ri-chat-3-line" />
              进入热评区
            </a>
          </div>
          <p className="mt-6 font-label text-xs tracking-wide text-foreground-500">
            本期收录 128 条 · 更新于 09.12 · 名单 / 排行 / 盘点 / 合集 持续更新
          </p>
        </div>

        <div className="lg:col-span-5">
          <div className="relative h-[320px] w-full overflow-hidden rounded-lg border border-background-200 md:h-[420px]">
            <img
              src="https://readdy.ai/api/search-image?query=Editorial%20flat%20lay%20of%20layered%20magazines%20and%20printed%20newspapers%20on%20a%20warm%20cream%20paper%20background%2C%20muted%20vermillion%20and%20gold%20accents%2C%20soft%20natural%20lighting%2C%20minimal%20elegant%20magazine%20composition%2C%20high%20detail&width=900&height=1100&seq=hlwh-hero-01&orientation=portrait"
              alt="黑料网红年度汇总 杂志式封面配图"
              className="h-full w-full object-top"
            />
            <span className="absolute bottom-4 left-4 inline-flex items-center gap-2 rounded-full bg-background-50/90 px-3 py-1.5 font-label text-[11px] text-foreground-800">
              <i className="ri-bookmark-line text-primary-600" />
              年度合辑封面
            </span>
          </div>
        </div>
      </div>

      <div className="mt-12 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4 md:mt-16">
        {heroCards.map((card: HeroCard, index: number) => (
          <HeroCardItem key={card.id} card={card} featured={index === 0} />
        ))}
      </div>
    </section>
  );
}